import { useQuery } from "react-query";
import { MindsightAuthSystemApi } from "../common/Api";

export const useAuthToggles = authUrl => {
  return useQuery(
    ["authToggles", authUrl],
    () => MindsightAuthSystemApi.getAuthToggles(authUrl),
    {
      enabled: !!authUrl
    }
  );
};
